import * as React from "react";
import { connect } from "react-redux";
import IupClassReportItemView from "./IupClassReportItemView";
import { createZippedPDF } from "../../actions/Action_Iup";
import axios from "axios";
import {
  ActionButton,
  DefaultButton,
  PrimaryButton,
  Dialog,
  Modal,
  Panel,
  PanelType,
  TextField,
  Label,
  MessageBar,
  MessageBarType,
  Spinner,
  SpinnerSize,
  Toggle,
  Stack,
  DialogFooter,
  DialogType
  //DatePicker
} from "office-ui-fabric-react";
import {
//   getIupReportForClass,
  createIUP,
  deleteIUP,
  getIupReportForClassDraft
} from "../../actions/Action_Iup";
import IupStudentreportForm from "./IupStudentreportForm";
import {ToastContainer, toast, Slide} from "react-toastify";
import * as moment from "moment";
export const LOCALE = "nb";
export const DATE_FORMAT = "DD.MM.YYYY";
export const TIME_FORMAT = "LT";
export interface IIupClassReportViewProps {
  iupClassReport: any;
  includeDraft: boolean;
  createIUP(iup: any);
  deleteIUP(iup: any);
  getIupReportForClassDraft(iup: any, includeDraft?: boolean);
  refreshSelectedIUP();
  iupViewToggleDraft();
  createZippedPDF(iups:any);
  setIupFormStatus(isDirty: boolean);
}
export interface IIupClassReportViewState {
  activestudent: any;
  showedit: boolean;
  title: string;
  allforms: any;
  activereport: any;
  deleting: boolean;
  wasdeleted: boolean;
  saving: boolean;
  zipurl:any[];
  generatingPfd: boolean;
  formIsDirty: boolean;
  browserPdfMode: boolean;
  browserPdfStudentId: any;
}
let text = "";
export class IupClassReportView extends React.Component<
  IIupClassReportViewProps,
  IIupClassReportViewState
> {
  // Max allowed JSON body size for ONE createZippedPDF request (IIS limit).
  // private static readonly MAX_TOTAL_POST_BYTES = 100 * 1024 * 1024;
  private static readonly MAX_TOTAL_POST_BYTES = 24 * 1024 * 1024;
  // Max allowed size for a single student item/part inside the post body.
  // This should be <= MAX_TOTAL_POST_BYTES.
  private static readonly MAX_SINGLE_STUDENT_BYTES = 1.8 * 1024 * 1024;


  private buildPdfDocumentHtml(bodyInnerHtml: string): string {
    return (
      "<!DOCTYPE html>" +
      "<html lang='nb'>" +
      "<head>" +
      "<title>PDF</title>" +
      "<meta charset='UTF-8' />" +
      "<style>.table {" +
      "width: 100%;" +
      "margin-bottom: 1rem;" +
      "border-collapse: collapse;" +
      "}" +
      ".table-bordered td,.table-bordered th {" +
      "border: 0.5px solid #696969;" +
      "padding: 5px;" +
      "text-align: left;" +
      "}" +
      ".table td {" +
      "padding: .75rem;" +
      "vertical-align: top;" +
      "}" +
      "span.form-1.kmeval {" +
      "color: #F0AD4E;" +
      "}" +
      "span.form-2.kmeval {" +
      "color: #1D4E90;" +
      "}" +
      "span.form-3.kmeval {" +
      "color: #5CB85C;" +
      "}" +
      ".kmeval {" +
      "padding-left: 10px;" +
      "}" +
      "</style>" +
      "</head>" +
      "<body>" +
      (bodyInnerHtml || "") +
      "</body>" +
      "</html>"
    );
  }

  private buildStudentInnerHtmlForReportRange(
    studentElement: Element,
    startReportIndexInclusive: number,
    endReportIndexInclusive: number,
    includeGeneral: boolean
  ): string {
    const cloned = studentElement.cloneNode(true) as HTMLElement;

    if (!includeGeneral) {
      const general = cloned.querySelector(".iup-general");
      if (general && general.parentNode) {
        general.parentNode.removeChild(general);
      }
    }

    const reports = Array.from(cloned.querySelectorAll(".iup-report"));

    if (reports.length > 0) {
      reports.forEach((node, idx) => {
        if (idx < startReportIndexInclusive || idx > endReportIndexInclusive) {
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        }
      });
    }

    return cloned.innerHTML;
  }

  private buildStudentInnerHtmlForReportChunk(
    studentElement: Element,
    reportIndex: number,
    reportChunkNodes: Node[],
    includeGeneral: boolean
  ): string {
    const cloned = studentElement.cloneNode(true) as HTMLElement;

    if (!includeGeneral) {
      const general = cloned.querySelector(".iup-general");
      if (general && general.parentNode) {
        general.parentNode.removeChild(general);
      }
    }

    const reports = Array.from(cloned.querySelectorAll(".iup-report")) as HTMLElement[];

    reports.forEach((report, idx) => {
      if (idx !== reportIndex) {
        if (report.parentNode) {
          report.parentNode.removeChild(report);
        }
        return;
      }

      const title = report.querySelector("h2");
      const titleClone = title ? title.cloneNode(true) : null;

      while (report.firstChild) {
        report.removeChild(report.firstChild);
      }

      if (titleClone) {
        report.appendChild(titleClone);
      }

      reportChunkNodes.forEach(node => {
        report.appendChild(node.cloneNode(true));
      });
    });

    return cloned.innerHTML;
  }

  private estimateReportChunkBytes(
    studentElement: Element,
    reportIndex: number,
    reportChunkNodes: Node[],
    includeGeneral: boolean,
    studentname: string,
    iupname: string
  ): number {
    const inner = this.buildStudentInnerHtmlForReportChunk(
      studentElement,
      reportIndex,
      reportChunkNodes,
      includeGeneral
    );
    const html = this.buildPdfDocumentHtml(inner);
    const partLabel = `${studentname} (del 9999 av 9999)`;

    return this.getUtf8ByteLength(
      JSON.stringify({ astudent: html, studentname: partLabel, iupname })
    );
  }

  private cloneElementWithChildren(element: HTMLElement, childNodes: Node[]): HTMLElement {
    const cloned = element.cloneNode(false) as HTMLElement;

    childNodes.forEach(child => {
      cloned.appendChild(child.cloneNode(true));
    });

    return cloned;
  }

  private splitTextNodeForReportChunk(
    textNode: Text,
    studentElement: Element,
    reportIndex: number,
    includeGeneral: boolean,
    studentname: string,
    iupname: string,
    maxBytes: number
  ): Node[] {
    const value = textNode.nodeValue || "";
    const pieces: Node[] = [];
    let remaining = value;

    while (remaining.length > 0) {
      let low = 1;
      let high = remaining.length;
      let best = 0;

      while (low <= high) {
        const mid = Math.floor((low + high) / 2);
        const candidate = document.createTextNode(remaining.substr(0, mid));
        const bytes = this.estimateReportChunkBytes(
          studentElement,
          reportIndex,
          [candidate],
          includeGeneral,
          studentname,
          iupname
        );

        if (bytes <= maxBytes) {
          best = mid;
          low = mid + 1;
        } else {
          high = mid - 1;
        }
      }

      if (best === 0) {
        throw new Error(
          `Tekstinnhold for ${studentname} er for stort til å sendes i en PDF-del.`
        );
      }

      let splitAt = best;
      if (best < remaining.length) {
        const lastSpace = remaining.substr(0, best).lastIndexOf(" ");
        if (lastSpace > 0) {
          splitAt = lastSpace + 1;
        }
      }

      pieces.push(document.createTextNode(remaining.substr(0, splitAt)));
      remaining = remaining.substr(splitAt);
    }

    return pieces;
  }

  private splitElementNodeForReportChunk(
    element: HTMLElement,
    studentElement: Element,
    reportIndex: number,
    includeGeneral: boolean,
    studentname: string,
    iupname: string,
    maxBytes: number
  ): Node[] {
    const pieces: Node[] = [];
    let currentChildren: Node[] = [];
    const childNodes = Array.from(element.childNodes);

    if (childNodes.length === 0) {
      throw new Error(
        `Innholdet i ${element.tagName} for ${studentname} er for stort til å splitte videre.`
      );
    }

    const pushCurrent = () => {
      if (currentChildren.length > 0) {
        pieces.push(this.cloneElementWithChildren(element, currentChildren));
        currentChildren = [];
      }
    };

    childNodes.forEach(child => {
      const candidate = this.cloneElementWithChildren(element, currentChildren.concat([child]));
      const candidateBytes = this.estimateReportChunkBytes(
        studentElement,
        reportIndex,
        [candidate],
        includeGeneral,
        studentname,
        iupname
      );

      if (candidateBytes <= maxBytes) {
        currentChildren.push(child);
        return;
      }

      pushCurrent();

      const childPieces = this.splitReportNodeForEstimatedPartSize(
        child,
        studentElement,
        reportIndex,
        includeGeneral,
        studentname,
        iupname,
        maxBytes
      );

      childPieces.forEach(childPiece => {
        const wrappedPiece = this.cloneElementWithChildren(element, [childPiece]);
        const wrappedPieceBytes = this.estimateReportChunkBytes(
          studentElement,
          reportIndex,
          [wrappedPiece],
          includeGeneral,
          studentname,
          iupname
        );

        if (wrappedPieceBytes > maxBytes) {
          throw new Error(
            `PDF-del for ${studentname} er fortsatt for stor etter splitting (ca. ${wrappedPieceBytes} bytes).`
          );
        }

        pieces.push(wrappedPiece);
      });
    });

    pushCurrent();

    return pieces;
  }

  private splitReportNodeForEstimatedPartSize(
    node: Node,
    studentElement: Element,
    reportIndex: number,
    includeGeneral: boolean,
    studentname: string,
    iupname: string,
    maxBytes: number
  ): Node[] {
    const nodeBytes = this.estimateReportChunkBytes(
      studentElement,
      reportIndex,
      [node],
      includeGeneral,
      studentname,
      iupname
    );

    if (nodeBytes <= maxBytes) {
      return [node];
    }

    if (node.nodeType === Node.TEXT_NODE) {
      return this.splitTextNodeForReportChunk(
        node as Text,
        studentElement,
        reportIndex,
        includeGeneral,
        studentname,
        iupname,
        maxBytes
      );
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      throw new Error(
        `PDF-innhold for ${studentname} er for stort og kan ikke splittes videre.`
      );
    }

    const element = node as HTMLElement;

    if (element.tagName === "IMG") {
      throw new Error(
        `Et bilde i rapporten til ${studentname} er for stort til å sendes alene.`
      );
    }

    return this.splitElementNodeForReportChunk(
      element,
      studentElement,
      reportIndex,
      includeGeneral,
      studentname,
      iupname,
      maxBytes
    );
  }

  private buildOversizedReportChunksByEstimatedPartSize(
    studentElement: Element,
    reportIndex: number,
    includeGeneral: boolean,
    studentname: string,
    iupname: string,
    maxBytes: number
  ): Node[][] {
    const report = Array.from(
      (studentElement as HTMLElement).querySelectorAll(".iup-report")
    )[reportIndex] as HTMLElement;

    const sourceNodes = Array.from(report.childNodes).filter(node => {
      return !(node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === "H2");
    });
    const chunks: Node[][] = [];
    let currentChunk: Node[] = [];

    const pushCurrentChunk = () => {
      if (currentChunk.length > 0) {
        chunks.push(currentChunk);
        currentChunk = [];
      }
    };

    sourceNodes.forEach(node => {
      const candidate = currentChunk.concat([node]);
      const candidateBytes = this.estimateReportChunkBytes(
        studentElement,
        reportIndex,
        candidate,
        includeGeneral,
        studentname,
        iupname
      );

      if (candidateBytes <= maxBytes) {
        currentChunk.push(node);
        return;
      }

      pushCurrentChunk();

      const nodePieces = this.splitReportNodeForEstimatedPartSize(
        node,
        studentElement,
        reportIndex,
        includeGeneral,
        studentname,
        iupname,
        maxBytes
      );

      nodePieces.forEach(nodePiece => {
        chunks.push([nodePiece]);
      });
    });

    pushCurrentChunk();

    return chunks;
  }

  private getUtf8ByteLength(input: string): number {
    if (typeof TextEncoder !== "undefined") {
      return new TextEncoder().encode(input).length;
    }

    return unescape(encodeURIComponent(input)).length;
  }

  private estimateIisPostBytesForIups(iups: any[]): number {
    return this.getUtf8ByteLength(JSON.stringify(iups));
  }

  private sanitizeIupNameForUrl(input: any): string {
    if (input == null) {
      return "IUP";
    }

    let value = String(input).trim();
    if (!value) {
      return "IUP";
    }

    if (typeof (value as any).normalize === "function") {
      value = value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
    }

    value = value
      .replace(/[^A-Za-z0-9_-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^[-_]+|[-_]+$/g, "");

    return value || "IUP";
  }

  private splitIupsByEstimatedPostSize(iups: any[], maxBytes: number): any[][] {
    const batches: any[][] = [];
    let currentBatch: any[] = [];
    let currentBatchBytes = 2; // []

    for (const item of iups) {
      let itemWithIndex = { ...item, Index: batches.length + 1 };
      let serializedItem = JSON.stringify(itemWithIndex);
      let itemBytes = this.getUtf8ByteLength(serializedItem);
      let itemAloneBytes = 2 + itemBytes;

      if (itemAloneBytes > maxBytes) {
        throw new Error(
          `PDF-forespørselen for en elev er for stor til å sendes (ca. ${itemAloneBytes} bytes).`
        );
      }

      const commaBytes = currentBatch.length > 0 ? 1 : 0;
      const prospectiveBytes = currentBatchBytes + commaBytes + itemBytes;

      if (currentBatch.length > 0 && prospectiveBytes > maxBytes) {
        batches.push(currentBatch);
        currentBatch = [];
        currentBatchBytes = 2;
      }

      itemWithIndex = { ...item, Index: batches.length + 1 };
      serializedItem = JSON.stringify(itemWithIndex);
      itemBytes = this.getUtf8ByteLength(serializedItem);
      itemAloneBytes = 2 + itemBytes;

      if (itemAloneBytes > maxBytes) {
        throw new Error(
          `PDF-forespørselen for en elev er for stor til å sendes (ca. ${itemAloneBytes} bytes).`
        );
      }

      const commaBytesAfterSplit = currentBatch.length > 0 ? 1 : 0;
      currentBatchBytes = currentBatchBytes + commaBytesAfterSplit + itemBytes;
      currentBatch.push(itemWithIndex);
    }

    if (currentBatch.length > 0) {
      batches.push(currentBatch);
    }

    return batches;
  }

  private buildStudentPdfItemsByEstimatedPartSize(
    studentElement: Element,
    studentname: string,
    iupname: string,
    maxBytes: number
  ): any[] {
    const element = studentElement as HTMLElement;
    const fullHtmlDoc = this.buildPdfDocumentHtml(element.innerHTML);
    const fullItem = { astudent: fullHtmlDoc, studentname, iupname };
    const fullItemBytes = this.getUtf8ByteLength(JSON.stringify(fullItem));

    if (fullItemBytes <= maxBytes) {
      return [fullItem];
    }

    const reportNodes = Array.from(element.querySelectorAll(".iup-report"));
    const reportCount = reportNodes.length;

    if (reportCount === 0) {
      throw new Error(
        `PDF-forespørselen for ${studentname} er for stor og har ingen delrapporter å splitte på (ca. ${fullItemBytes} bytes).`
      );
    }

    const estimateRangeBytes = (
      startIdx: number,
      endIdx: number,
      includeGeneral: boolean
    ) => {
      const inner = this.buildStudentInnerHtmlForReportRange(
        element,
        startIdx,
        endIdx,
        includeGeneral
      );
      const html = this.buildPdfDocumentHtml(inner);
      const partLabel = `${studentname} (del ${reportCount} av ${reportCount})`;
      return this.getUtf8ByteLength(
        JSON.stringify({ astudent: html, studentname: partLabel, iupname })
      );
    };

    const ranges: any[] = [];
    let startIdx = 0;

    while (startIdx < reportCount) {
      const includeGeneral = ranges.length === 0;
      let endIdx = startIdx;
      let bestEndIdx = -1;

      while (endIdx < reportCount) {
        const bytes = estimateRangeBytes(startIdx, endIdx, includeGeneral);
        if (bytes > maxBytes) {
          break;
        }

        bestEndIdx = endIdx;
        endIdx++;
      }

      if (bestEndIdx === -1) {
        if (includeGeneral) {
          const generalOnlyBytes = estimateRangeBytes(0, -1, true);
          if (generalOnlyBytes <= maxBytes) {
            ranges.push({ startIdx: 0, endIdx: -1, includeGeneral: true });
            continue;
          }
        }

        const singleReportBytes = estimateRangeBytes(startIdx, startIdx, false);
        console.warn(
          `IUP PDF: splitting oversized individual report for ${studentname}`,
          {
            reportIndex: startIdx,
            singleReportBytes,
            maxSingleStudentBytes: maxBytes
          }
        );

        const reportChunks = this.buildOversizedReportChunksByEstimatedPartSize(
          element,
          startIdx,
          false,
          studentname,
          iupname,
          maxBytes
        );

        reportChunks.forEach(chunkNodes => {
          ranges.push({
            reportIndex: startIdx,
            reportChunkNodes: chunkNodes,
            includeGeneral: false
          });
        });
        startIdx++;
        continue;
      }

      ranges.push({ startIdx, endIdx: bestEndIdx, includeGeneral });
      startIdx = bestEndIdx + 1;
    }

    const totalParts = ranges.length;
    return ranges.map((range, index) => {
      const partLabel = `${studentname} (del ${index + 1} av ${totalParts})`;
      const inner = range.reportChunkNodes
        ? this.buildStudentInnerHtmlForReportChunk(
            element,
            range.reportIndex,
            range.reportChunkNodes,
            range.includeGeneral
          )
        : this.buildStudentInnerHtmlForReportRange(
            element,
            range.startIdx,
            range.endIdx,
            range.includeGeneral
          );
      const item = {
        astudent: this.buildPdfDocumentHtml(inner),
        studentname: partLabel,
        iupname
      };
      const itemBytes = this.getUtf8ByteLength(JSON.stringify(item));

      if (itemBytes > maxBytes) {
        throw new Error(
          `PDF-del ${index + 1} for ${studentname} er for stor til å sendes (ca. ${itemBytes} bytes).`
        );
      }

      return item;
    });
  }

  constructor(props) {
    super(props);
    let t = "";
    if (this.props.iupClassReport) {
      t = this.props.iupClassReport.Name;
    }
    this.state = {
      activestudent: null,
      showedit: false,
      title: t,
      allforms: {},
      activereport: null,
      deleting: false,
      wasdeleted: false,
      saving: false,
      generatingPfd: false,
      zipurl:[],
      formIsDirty: false,
      browserPdfMode: false,
      browserPdfStudentId: null
    };
  }
  componentWillReceiveProps(nextprops: IIupClassReportViewProps) {
    this.setState({ wasdeleted: false, activestudent: null });

    if (nextprops.iupClassReport.Id != this.props.iupClassReport.Id) {
      this.setState({formIsDirty: false});
    }
  }
  componentDidMount() {
    if(this.props.iupClassReport && this.props.iupClassReport.Name){
      text = this.props.iupClassReport.Name;
    }
  }

  setActiveStudent = (student: any) => {
    let changeStudentConfirmation = this.state.formIsDirty ? confirm("Du har ulagrede endringer, er du sikker på at du vil bytte elev?") : true;
    
    if (changeStudentConfirmation) {
      student.Report.StudentLogin = student.LoginName;
      student.Report.Iupid = this.props.iupClassReport.Id;
      this.setState({
        activestudent: student,
        activereport: student.Report
      });
    }
  }

  setFormStatus = (isDirty: boolean) => {
    this.setState({formIsDirty: isDirty});
    this.props.setIupFormStatus(isDirty);
  }

  private startBrowserPdfForActiveStudent = () => {
    if (!this.state.activestudent) {
      return;
    }

    const studentId = this.state.activestudent.Id;
    this.setState({
      browserPdfMode: true,
      browserPdfStudentId: studentId
    });
  };

  private closeBrowserPdfMode = () => {
    this.setState({ browserPdfMode: false, browserPdfStudentId: null });
  };

  private renderStudentPdf = (student: any) => {
    if (!student) {
      return null;
    }

    return (
      <div className={"studentpdf"} id={`pdf-${student.Id}`}>
        <h1>{student.Name}</h1>
        <div className="iup-general">
          <h3>Generell tilbakemelding</h3>
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: student.Report.BackEval
              }}
            ></span>
          </div>
          <h3>Generell framovermelding</h3>
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: student.Report.FutureEval
              }}
            ></span>
          </div>
          <h3>Kommentar fra elevsamtale</h3>
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: student.Report.BackComment
              }}
            ></span>
          </div>
          <h3>Kommentar fra kontaktsamtale</h3>
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: student.Report.FutureComment
              }}
            ></span>
          </div>
        </div>

        {student.Reports.map((rep, repIndex) => {
          return (
            <div
              className="iup-report"
              data-report-index={repIndex}
              key={`rep-${student.Id}-${repIndex}`}
            >
              <h2>{rep.Title}</h2>
              <div className="table-responsive">
                <h3>Innleveringer</h3>
                <table className="table table-bordered">
                  <tbody>
                    {rep.Tasks.map((task, taskIndex) => {
                      return (
                        <tr
                          className="taskrow"
                          key={`task-${student.Id}-${repIndex}-${taskIndex}`}
                        >
                          <td>
                            <span className="taskname">{task.WsTask.Name}</span>
                          </td>
                          <td>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: task.GradingComment
                              }}
                              className="taskcomment"
                            ></span>
                          </td>
                          <td>
                            <span className="taskgrade">{task.Grade}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="table-responsive">
                <h3>Prøver</h3>
                {rep.Quis && rep.Quis.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Tittel</th>
                        <th>Kommentar</th>
                        <th>Karakter</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rep.Quis.map((qa, quizIndex) => {
                        return (
                          <tr
                            className="taskrow"
                            key={`quiz-${student.Id}-${repIndex}-${quizIndex}`}
                          >
                            <td>
                              <span className="quizname">{qa.Quiz.Title}</span>
                            </td>
                            <td>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: qa.GradingComment
                                }}
                                className="quizcomment"
                              ></span>
                            </td>
                            <td>
                              <span className="quizgrade">{qa.Grade}</span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <p style={{paddingLeft: '5px', color: "#696969"}}>Ingen Prøver</p>
                )}
              </div>
              <div className="table-responsive">
                <h3>Kompetansemål</h3>
                {rep.Kmevals && rep.Kmevals.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Kompetansemål</th>
                        <th>Måloppnåelse</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rep.Kmevals.map((km, kmIndex) => {
                        return (
                          <tr
                            className="kmrow"
                            key={`km-${student.Id}-${repIndex}-${kmIndex}`}
                          >
                            <td className="kmtext">{km.Kmtext}</td>
                            <td>
                              {km.Evals.map((ev, evIndex) => {
                                const iconSrcs = {
                                  TestBeaker: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAC50lEQVRYR+2XSUwTURzGv9fpTDszQIPgLiAJLsSFSCCGohCMiScPnjRejAc9mJhoPGiCS10wejCaeNOD8WL05MGTFw0oEAPB4BJcSFBwQ0ECOJ2WWZ6Zqa1iy8ybUBNM+q7v3///12/m+94bQimlmAOL/JcgP1qPwRjtY9KPK6pEXuMFplqryJMiSscZGKOvQXUVoCYILwKESwyjBqimAsQH4hfBFa2CHD75b0CsrmbsO5S2ZlB1BGL1QfAlDfYwbagNas9VELEYckMLfMF5zBCeFcmBZNI292j+ViWnSE4RtxTSv/Yi+uSinaByfQRcYYX9E2OsH0p7xE5caeNR+BdUubWatu8p4kEprJjXh3vAL6mzB4KQXxFPbUDtUyf8C6sT8Z7cY0DyBDI1cB9q73UQIQ9yXTO4whXTRhhjb6F0tgCaguCGAxBKmxgQEiXMIHRqEsqjEzDG3yGwcgeCa/dkHBJ7cRPxN3fBhZZD3nwWRMhngmEGiffdQezVbfjkRY6HWjJnTOULgqt3IVC5M3sgxsR7RB9HYE5NQqzaB6F8m2Pz5CP0CfmQNkXAFZS5wjApEu2+Am3wIfzFayDVnwLhAo6NqRFHtP009JGX4EubINUcmj1Iyq7UhFh7BPziWtem9v3kcxfUrku2zVns7KiI/c86zkH/9gx8SSOkmsPslqQU0e7L0IZa4Z+/HlL4uKOSjiApu/o48KVbQAIFTGoki2h8AtrgA1DTcH23ZgT5bdcBT8NnKuZC5Y52nhEkmQckEAJXsGxWMMbEB9D4uGP+ZATxalc3ShY7ZwRJ2ZXhJXODsPZZ7JwG4tV2LCBWjVsMpIHYJ+jHDuYgYgWx6pJK80vDiZP7j5UGYt0p9OGnCFbuZj4nWGHs86rvlp3QcsN5Z5B4/z3Ent+wvulA/JKdjFlZ1ATVowB8CK7bi0DFdmcQ6/Kj9l5LBJEeywpDqgknQCjbCrFqf1pCMx162aXJ3G3OgPwEG1IquVqBwS0AAAAASUVORK5CYII=",
                                  TestBeakerSolid: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAC8UlEQVRYR+2Xe0hTcRTHv1PnXBmTJjGkFOlh0EMq7TV6MuihllhUJFqSI4QZEZZpIzFM00ZEDkbMyDSjp0hqDxi9YPbYKuwB2cu0GCO0HFlTN138rl1hut17B3dgsPPv+e2czz3nfr+/XYHL5XJhHITgvwQpqzFCd8PMaX45WxJQkCnndJYc8mkiuvrnaDZ+QIe1B7/tDsyYOhlhoSFUs74BJz5++4GJYiFiZBFIks9ETtoi/4CQqvZ+J/K1BpjeWVBblErBkCAQGcUNSJwdhXKVAmLRMCDX8GkiARBPYw2sZvRUAhMJTITNgCxdv7DneCPlqFWFKZBKxNRPum12ZJc2Ug577kgKoiInsZVyy/tkaOSe1tWbcaLGiGLlauxOiodAMFyP5KqbW1Gkf4DDmXLkpCWM5LgQ+QTy5tN3ZJXcpGy9Mm89IiUT3Hp02f4gV3MHX6w9qFZvRlyMlAsDdYYzyIBjEEX6h7hieIuqwmSsTYj12OSeuR3ZpU3YrpiDYuUqhAqDOcFwBjG2foWyrAmKxFjGS432GYOpHfqCZMjjp/EH0tPbB5XmNto6unFevQlzp09hLE6vkKxGm7cBEeFhrDCcJkLWcbDSgH3bFmP/jiUICQ5iLOwcHMLpy09x5uoznMxVUGtiC1YQWq4O5xAlyxiZhK0mle+w2iiZC0OCOMmZEYQ8mfa6CacuPUGFavjJaLmy0RA5k0ke0hpwYOdSqLYmMk6SEYTetVgkRH7GckjCRWz93fK23n6U17bA3u9gfbe8gtByrbv72qfm3g6nr5vHKGevILQfkPXwEeQFZ/IfjyC0XB+97OSDYaTGygXRXuXsEYSWK68U/4p5k/MYEFp27zu7/cGBWdFSjzYwBqTm1iuoz973CwRdtGTvGmRunO/WYwyI9poJFRdb/ApCHDovfRkzyIs2K3YdawDxAH8E8aILR1OxME7GDEIckXzfauoe47PlJ68s5F+bOmsF9V082qFZ7xpeSRiKjRuQv9jdCbnUbfpKAAAAAElFTkSuQmCC",
                                  TestCase: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAACuElEQVRYR+2XPUhbURTH/6+JSTQ2WhrBahsrFBNIbQjFDk7iB4qjm8ZNHATBTRCdnARdnARBQRB1EDcHwcHFodS2akiTEEJpKYVqbRuVYL585Tx6Q2Je8m58MWboWd+55/7e/3zcewVRFEWUgAklBXISPsH022mEoqGCa9Pd0I1B26BiXEkRBnIZu0RFWQUECIoLlRzi13GE42HcCqRKX4WJlglUllUq7aP4fe/bHpY8S/9BkkrdmyIiRBz/PIa12gqD1oB7ASGIzcAmtj9vw1HjwKhjFPvf94tbI6kQOo0OI69G4KxxFleRbBBUKEVLTS6IooEoQRQMRK/RY92/jjpjHTotnWnDiweCFlwlrnAeOZcmNc+ATBvxbLIenR5h+dMy6GAesA4kYXghFMeujIMsCP3B7tddrPnXpCUE02HpSLZoanewmL7fPiy6FxFJRHJyuGwutD5pzfDJCkKeqTCNpkYEQ0HIQZCv+8yN+Y/ziiBD9iG0PW3LDyQVJnYdQ7m2PDknsv02a9tmczPGX49j1beKnS87yAbA4uRUhDmRMlvBLQy/HJaGVS67UxDWBQaNQbEO7xxEkeCfA6m34l3BzdT0W/vR+7w3axiu1PBCUB3Nvp8FdRB1Wk9DDw5+HGDBvQCzwYzJN5Mw6Uyy4dJAtA+06LJ0SZ2Rj9Hgsz+2y24qBycXOw3kNpdnmsJjzjHYHtky1GAb8qgigRDAhn9Duuzma/XGevS96MPh6WHWFPCoUpB3Dc9GSqoUBIRtQmo2VTfJ1hg9LwJ/AtJhyAo5VX3VIEwN7y8vd1apuG92kGoQpkY0EeUGEQQhQxVVICT33Ic5eM483BDM0fLQkvaYUwVC+Z55NyOdyvlarbEWUy1ToDsQmSoQCkCpoUvURfSCm4UGpsvqQvuz9uQa1SDcuys4lgzIX2Q5lblKoEziAAAAAElFTkSuQmCC",
                                  Error: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAERUlEQVRYR+1XWSh1bRR+jiGEJFHccCHDjeHCdIGEUCRxYR7iwlgkQ0kIEWXMPGXmAimEK9ygyFSGpBRFiYwZ42+9/ft09nHO3ufQ//f99b+3+33Xft5nrfWs55V8fX194Q9Ykv8cECLu/Pwcc3NzWFpawtbWFo6OjhiXlpaWcHR0hI+PDwICAmBrawsNDQ21eBZl5PPzE8vLy6irq8PMzAwvuLu7O7S1tbG9vY2HhwfpN09PTxQUFMDPzw86OjoqARIEcnl5iaKiIvT29sLQ0BBhYWFISkqCs7MzjIyMeD94fHxkgMbGxjA6OoqbmxsEBwejtrYWdnZ2omCUAtnc3ERGRgbW19cRHx+PsrIyWFlZiQakDRcXF2hsbERrayssLCzQ0NDAUiaRSJSeVwhkdXUVaWlpODs7YymJiYmBlpaWSiC4TVRTCwsLyM7OxsvLC/r7++Ht7a06kOPjY8TFxYHS0tbWhsDAQMGbiKHjLqWrq4u+vj7Y29srPMJj5Pn5Gfn5+Qx9e3s7oqKifgWC+yMVe0JCAlxdXdHR0QFjY+NvYHhAFhcXERERwQ7V1NRAT09P6YXf3t4wMTGBu7s7xMbGwsDAQOnej48PVFdXo7i4GENDQyzV8ksK5OnpCZmZmaw4qfIdHBwEWSf2cnJycHp6iuHhYZiYmAjup30E2MzMDD09Pd9YkQLZ3d1lbAQFBTE2xPpfXSBUvPX19SgtLcXU1BR8fX15wKVAKHepqamg9Pj7+4vVINQFQgFJEkJCQpCens70SbadGRDKd2FhIVZWVlharK2t/xEgV1dXiI6Ohrm5OVpaWphIcosBoYJLSUlhMq1KvunwTxgROsOAXF9fs0om5aQ8CnULd4PfAFlbW8P4+DgbjjxG/hgg/3ZqTk5OMDIyAlNTUz4jNAtyc3PZ9KQN5C/EFp2prKxko4DaXZFaysfgmKci7e7u5k3wH7evGFBF3zmtIr0qLy+HpqYmnxHZHqfuKSkp4W1SFJQE6v7+HmScyJuIOTJO0Ih5RVr1TeLJAspXtCIg6nYNeRTyNbQGBgaYlsgu3tCbnp5mFiArK4sZISEPos7QIzaampqYN+ns7GSaJW+SeECIagJBs2BwcBChoaE/KYVvZzgbQAa7q6uLDT6l05f7cHBwwHzp7e0tQ+/l5fUrMFw86i4hl6bQKnI3IFelit9UVswbGxuM4f39fVGjpRAI5XR+fp75VnLjNC2p2mUFSIgm8jbEZkVFBdvW3NyMyMhIwc4SfE4cHh4iLy+PvWdI5JKTkxEeHg4bG5tvhUxtTGZ7cnKS2UF6fLm4uDBGPTw8RC2n6APr9fWVBa+qqsLe3h67ISmjk5OTdDi+v79jZ2eHsUeLhhmlJDExEfr6+irVmCgQLgr5TrKRs7OzLG2kN7KLfk5vF3qEubm5qTTBleqIStD/3qSusorFVpkRsUC//f4/EHkG/wLzRNy5CeDJewAAAABJRU5ErkJggg=="
                                };
                                let iconSrc;
                                if (ev === '1') iconSrc = iconSrcs.TestBeaker;
                                else if (ev === '2') iconSrc = iconSrcs.TestBeakerSolid;
                                else if (ev === '3') iconSrc = iconSrcs.TestCase;
                                else iconSrc = iconSrcs.Error;
                                return (
                                  <span className={`form-${ev} kmeval`} key={`kmeval-${evIndex}`}>
                                    <img src={iconSrc}/>
                                  </span>
                                );
                              })}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <p style={{paddingLeft: '5px', color: "#696969"}}>Ingen Kompetansemål</p>
                )}
              </div>
              <h3>Tilbakemelding</h3>
              <span dangerouslySetInnerHTML={{ __html: rep.ReportText }}></span>
              <h3>Framovermelding</h3>
              <span dangerouslySetInnerHTML={{ __html: rep.Future }}></span>
            </div>
          );
        })}
      </div>
    );
  };

  public render() {
    // this.state.generatingPfd &&
    //    ( <Dialog
    //   hidden={false}
    //   onDismiss={() => this.setState({ generatingPfd: false })}
    //   >
    //   <Stack>
    //     <Label>Genererer pdf</Label>
    //     <Spinner size={SpinnerSize.large} />
    //   </Stack>
    //   <span>Genererer pdf, vennligst vent</span>
    //   <DialogFooter>
    //     <ActionButton>Hei hei hallå</ActionButton>
    //     {console.log("jeg finnes")}
    //   </DialogFooter>
    // </Dialog>)
    
    if (this.state.wasdeleted) {
      return <div>IUP slettet</div>;
    }

    const activeStudentForPrint =
      this.props.iupClassReport &&
      this.state.browserPdfMode &&
      this.state.browserPdfStudentId != null
        ? this.props.iupClassReport.Students.find(
            s => s.Id === this.state.browserPdfStudentId
          )
        : null;

    return (
      <div id="detailView" className="iup-content">
        <ToastContainer transition={Slide}/>
        {this.state.browserPdfMode && (
          <style>
            {`
              /* Print-mode: remove scroll containers so all pages render */
              * {
                overflow: visible !important;
                height: auto !important;
                max-height: none !important;
              }
              html, body {
                height: auto !important;
                overflow: visible !important;
                position: static !important;
              }
              #root, #detailView, .iup-content, #single-student-print {
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
                position: static !important;
              }
              .ms-Grid,
              .ms-Grid-row,
              .ms-Grid-col,
              .ms-Layer,
              .ms-Overlay,
              .table-responsive,
              .studentpdf {
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
                position: static !important;
              }
              
              @media print {
                * {
                  overflow: visible !important;
                  height: auto !important;
                  max-height: none !important;
                  position: static !important;
                }
                html, body {
                  height: auto !important;
                  overflow: visible !important;
                  margin: 0 !important;
                  padding: 0 !important;
                  position: static !important;
                }
                #root, #detailView, .iup-content, #single-student-print, .studentpdf {
                  height: auto !important;
                  max-height: none !important;
                  overflow: visible !important;
                  position: static !important;
                }
                .ms-Grid,
                .ms-Grid-row,
                .ms-Grid-col,
                .ms-Layer,
                .ms-Overlay,
                .table-responsive {
                  height: auto !important;
                  max-height: none !important;
                  overflow: visible !important;
                  position: static !important;
                }
                /* Hide close button in print */
                #single-student-print > div:first-child {
                  display: none !important;
                }
                /* Hide headers, navigation, dropdowns */
                header,
                nav,
                .ms-CommandBar,
                .ms-Dropdown,
                .page-header,
                .pageheader,
                h4,
                .ms-Toggle {
                  display: none !important;
                }
                /* Hide IUP view header elements */
                #getIUP > .ms-Grid-row:first-child {
                  display: none !important;
                }
                /* Hide IUP view page header and dropdowns */
                .topTool,
                .header-view,
                .container.main > .ms-Grid-row:first-child,
                .container.main > div:first-child:not(#iup-page) {
                  display: none !important;
                  height: 0 !important;
                  margin: 0 !important;
                  padding: 0 !important;
                }
                /* Remove margins from container */
                .container.main,
                .container {
                  margin: 0 !important;
                  padding: 0 !important;
                }
                /* Ensure print content starts at top */
                #iup-page,
                #single-student-print {
                  margin-top: 0 !important;
                  padding-top: 0 !important;
                }
              }
            `}
          </style>
        )}
        {this.state.browserPdfMode && (
          <div id="single-student-print">
            <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
              <PrimaryButton
                iconProps={{ iconName: "Cancel" }}
                text="Lukk"
                onClick={this.closeBrowserPdfMode}
              />
            </div>
            {this.renderStudentPdf(activeStudentForPrint)}
          </div>
        )}
        {this.props.iupClassReport && (
          <div
            className="ms-Grid-row"
            id="getIUP"
            style={{ display: this.state.browserPdfMode ? "none" : "block" }}
          >
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12 ms-lg8">
                <h4>
                  {this.props.iupClassReport.Name} |{" "}
                  {/* {this.props.iupClassReport.Name}  */}
                  <span className="text-muted">
                    {" "}
                    Fra:
                    {moment(this.props.iupClassReport.From)
                      .locale(LOCALE)
                      .format(DATE_FORMAT)}{" "}
                    Til:{" "}
                    {moment(this.props.iupClassReport.To)
                      .locale(LOCALE)
                      .format(DATE_FORMAT)}{" "}
                  </span>
                </h4>
                <Toggle label="Inkluder ufullstendige rapporter?" onText="Ja" offText="Nei" defaultChecked={this.props.includeDraft} onChange={this.props.iupViewToggleDraft} />
              </div>
              <div className="ms-Grid-col ms-md12 ms-lg4">
                {!this.props.iupClassReport.Hasreports && (
                  <div>
                    <DefaultButton 
                      iconProps={{ iconName: "Edit", color: "green" }}
                      text="Endre tittel på IUP"
                      onClick={() => {
                        this.setState({ showedit: true });
                      }}
                    />

                    <DefaultButton
                      iconProps={{ iconName: "Delete", color: "red" }}
                      text="Slett IUP"
                      styles={{
                        root: {
                          marginLeft: 5
                        }
                      }}
                      onClick={() => {
                        let i: any = {};
                        i.Id = this.props.iupClassReport.Id;
                        this.setState({ deleting: true });
                        this.props.deleteIUP(i).then(() => {
                          this.setState({
                            showedit: false,
                            deleting: false,
                            wasdeleted: true
                          });
                          this.props.getIupReportForClassDraft(this.props.iupClassReport.Id, this.props.includeDraft);
                        });
                      }}
                    />
                    {this.state.deleting && (
                      <Spinner size={SpinnerSize.large} ariaLive="assertive" />
                    )}
                  </div>
                )}
                {this.props.iupClassReport.Hasreports && (
                  <div>
                    <MessageBar
                      messageBarType={MessageBarType.warning}
                      isMultiline={false}
                    >
                      Denne IUP'en kan ikke endres
                    </MessageBar>
                  </div>
                )}
              </div>
              <Panel
                isOpen={this.state.showedit}
                onDismiss={() => {
                  this.setState({ showedit: false });
                }}
                type={PanelType.smallFixedFar}
                headerText="Endre IUP"
              >
                <div>
                  <TextField
                    label="Tittel"
                    onChange={(t, val) => {
                      text = val;
                    }}
                    defaultValue={this.props.iupClassReport.Name}
                  />

                  <PrimaryButton
                    styles={{
                      root: {
                        marginTop: 24
                      }
                    }}
                    text="Lagre"
                    onClick={() => {
                     let i: any = {};
                     i.Id = this.props.iupClassReport.Id;
                     i.Name = text;
                     this.setState({ saving: true });
                     this.props.createIUP(i).then(() => {
                       this.setState({
                         showedit: false,
                         title: i.Name,
                         saving: false
                       });
                      this.props.refreshSelectedIUP();
                      });
                    }}
                  />
                  {this.state.saving && (
                    <Spinner size={SpinnerSize.large} ariaLive="assertive" />
                  )}
                  <DefaultButton
                    styles={{
                      root: {
                        marginTop: 24
                      }
                    }}
                    text="Avbryt"
                    onClick={() => {
                      this.setState({ showedit: false });
                    }}
                  />
                </div>
              </Panel>
            </div>
            <div className="ms-Grid-row content-row">
              <div className="ms-Grid-col ms-sm12 ms-lg4">
                <h4>Elever</h4>
                <ul className="iup-students">
                  {this.props.iupClassReport.Students.map(item => {
                    let classn = "";
                    if (
                      this.state.activestudent &&
                      item.Id == this.state.activestudent.Id
                    ) {
                      classn = "selected";
                    }
                    return (
                      <li
                        className={`load-student-report ${classn}`}
                        onClick={() => this.setActiveStudent(item)}
                      >
                        {item.Report.Published && (
                          <div className="iup-student-haspublished-report pubicon-@student.LoginName.Split('@')[0]">
                            <i
                              className="ms-Icon ms-Icon--BoxCheckmarkSolid green"
                              aria-hidden="true"
                            ></i>
                            <span className="iup-student-name">
                              <span className="iup-student-name">
                                {item.Name} ({item.Reports.length})
                              </span>
                            </span>
                            <div>Rapport er publisert</div>
                          </div>
                        )}
                        {!item.Report.Published && (
                          <div className="iup-student-hasnotpublished-report notpubicon-@item.LoginName.Split('@')[0]">
                            <i className={`fas fa-pen-square ${item.Report.Id === 0 ? 'orange' : 'blue'}`}></i>
                            <span className="iup-student-name">
                              {item.Name} ({item.Reports.length})
                            </span>
                            {item.Report.Id === 0 && (
                              <div>Rapport er ikke påstartet</div>
                            )}
                            {item.Report.Id !== 0 && (
                              <div>Rapport er kladdet</div>
                            )}
                          </div>
                        )}
                      </li>
                    );
                  })}
                  <li></li>
                </ul>
              { this.state.generatingPfd ? (<Stack>
                <Label style={{textAlign: "center"}}><b>Genererer pdf...</b></Label>
                <Spinner size={SpinnerSize.large} />
                </Stack>) : 
                <ActionButton
                  iconProps={{ iconName: "pdf" }}
                  styles={{
                    root: {
                      float: "right"
                    }
                  }}
                  text="Opprett PDF for alle"
                  onClick={() => {
                    this.setState({
                      generatingPfd: true
                    })
                    let allstudents = document.getElementsByClassName(
                      "studentpdf"
                    );
                    let postdata = [];
                    const skippedStudents: any[] = [];

                    const addPostDataItem = (item: any) => {
                      const bytes = this.getUtf8ByteLength(JSON.stringify(item));
                      console.log("IUP PDF: add postdata item", {
                        studentname: item && item.studentname ? item.studentname : "",
                        iupname: item && item.iupname ? item.iupname : "",
                        bytes
                      });
                      postdata.push(item);
                    };

                    for (let index = 0; index < allstudents.length; index++) {
                      const element = allstudents[index] as Element;
                      const h1 = (element as HTMLElement).getElementsByTagName("H1")[0];
                      const studentname = h1 ? h1.innerHTML : "";

                      try {

                        const classIdRaw = this.props.iupClassReport.ClassID;
                        const classIdParts = classIdRaw != null ? String(classIdRaw).split("|") : [];
                        const classId = classIdParts.length > 1 ? classIdParts[1] : classIdParts[0];

                        const iupnameUnsafe = classId
                          ? `${this.props.iupClassReport.Name}-${classId}`
                          : this.props.iupClassReport.Name;
                        const iupname = this.sanitizeIupNameForUrl(iupnameUnsafe);

                        const studentPdfItems = this.buildStudentPdfItemsByEstimatedPartSize(
                          element,
                          studentname,
                          iupname,
                          IupClassReportView.MAX_SINGLE_STUDENT_BYTES
                        );

                        if (studentPdfItems.length > 1) {
                          console.log("IUP PDF: split oversized student", {
                            studentname,
                            iupname,
                            parts: studentPdfItems.length,
                            maxSingleStudentBytes: IupClassReportView.MAX_SINGLE_STUDENT_BYTES
                          });
                        }

                        studentPdfItems.forEach(addPostDataItem);
                        continue;
                      } catch (err) {
                        console.error("IUP PDF: failed to process student (skipping)", err);
                        skippedStudents.push({ index, reason: "exception", error: err, studentname: studentname });
                        continue;
                      }
                    }

                    try {
                      if (skippedStudents.length > 0) {
                        console.warn("IUP PDF: skipped students", skippedStudents);
                        toast.warn(
                          <div>
                            <div><strong>{skippedStudents.length} rapporter var for store til å generere PDF og ble hoppet over. Prøv kortere innhold eller færre bilder.</strong></div>
                            <div style={{ marginTop: '10px' }}>Følgende elever ble hoppet over:</div>
                            {skippedStudents.map(s => (
                              <div key={s.studentname}>{s.studentname}</div>
                            ))}
                          </div>,
                          { autoClose: 12000 }
                        );
                      }

                      if (postdata.length === 0) {
                        console.error("IUP PDF: no students to generate PDF for (all skipped)", {
                          skippedStudentsCount: skippedStudents.length
                        });
                        toast.error(
                          "Alle rapportene var for store til å generere PDF. Prøv kortere innhold eller færre delrapporter."
                        );
                        this.setState({ generatingPfd: false });
                        return;
                      }

                      const batches = this.splitIupsByEstimatedPostSize(
                        postdata,
                        IupClassReportView.MAX_TOTAL_POST_BYTES
                      );
                      const urls: any[] = [];
                      let requestChain = Promise.resolve();

                      console.log("IUP PDF: sending PDF batches", {
                        batches: batches.length,
                        items: postdata.length,
                        maxTotalPostBytes: IupClassReportView.MAX_TOTAL_POST_BYTES
                      });

                      batches.forEach((batch) => {
                        requestChain = requestChain.then(() => {
                          return this.props.createZippedPDF(batch).then((resp) => {
                            const url = resp && resp.payload && resp.payload.data ? resp.payload.data.Name : "";
                            if (url) {
                              urls.push({ url });
                            }
                          });
                        });
                      });

                      requestChain.then(() => {
                        this.setState({ zipurl: urls, generatingPfd: false });
                      }).catch((e) => {
                        console.error("Kunne ikke generere PDF-forespørselen:", e);
                        alert(
                          "En eller flere rapporter er for store til å generere PDF. Prøv færre elever eller kortere innhold."
                        );
                        this.setState({ generatingPfd: false });
                      });
                    } catch (e) {
                      console.error("Kunne ikke splitte PDF-forespørselen:", e);
                      alert(
                        "En eller flere rapporter er for store til å generere PDF. Prøv færre elever eller kortere innhold."
                      );
                      this.setState({ generatingPfd: false });
                    }
                    // this.props.createZippedPDF( postdata).then((resp)=>{
                    //   console.log('zip',resp);
                    //   this.setState({zipurl:resp.payload.data.Name, generatingPfd: false});
                     
                    // })
                  }}
                />}
               
                {
                  this.state.zipurl && this.state.zipurl.length>0 &&
                  this.state.zipurl.map((urlitem, index)=>{
                    const totalParts = this.state.zipurl.length;
                    return(
                      <a href={urlitem.url} target="_blank" rel="noopener noreferrer">
                        <ActionButton
                        key={`pdf-part-${index}`}
                        iconProps={{ iconName: "download" }}
                        text={`Last ned PDF del ${index + 1} av ${totalParts}`}
                        styles={{
                          root: {
                            display: "block",
                            float: "none",
                            textAlign: "left"
                          },
                          label:{
                            color: "#0645AD",
                            fontWeight: 600
                          },
                          icon:{
                            fontWeight: 600,
                            color: "#32CD32"
                          }
                        }}/>
                      </a>
                    )
                  })
                
                }
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8">
                <div>
                  {this.state.activestudent && (
                    <DefaultButton
                      iconProps={{ iconName: "Print" }}
                      text="Opprett PDF (nettleser)"
                      styles={{
                        root: {
                          marginBottom: 12
                        }
                      }}
                      onClick={this.startBrowserPdfForActiveStudent}
                    />
                  )}
                  {this.state.activestudent && (
                    // <IupClassReportItemView
                    //   item={this.state.activestudent}
                    //   // iupid={this.props.iupClassReport.Id}
                    // ></IupClassReportItemView>
                    <IupStudentreportForm
					            initialValues={this.state.activereport}
					            toggleDraft={this.props.iupViewToggleDraft}
                      student={this.state.activestudent}
                      includeDraft={this.props.includeDraft}
                      setFormStatus={this.setFormStatus}
                      onemitform={props => {

                      }}
                    ></IupStudentreportForm>
                  )}
                </div>
              </div>
              <div id="allpdf" style={{ display: "none" }}>
                {this.props.iupClassReport.Students.filter(student => student.Report.Published).map(student => {
                  return this.renderStudentPdf(student);
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, {
  createIUP,
  deleteIUP,
  createZippedPDF, 
  getIupReportForClassDraft
})(IupClassReportView);
